import { RefCallback } from 'preact'
import { useCallback, useRef } from 'preact/hooks'
import { stopAllEventsPropagation } from '../helpers/events'

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {}

export interface UseStopEventsPropagation {
  ref: RefCallback<HTMLElement>
}

export const useStopEventsPropagation = (): UseStopEventsPropagation => {
  const cleanupFn = useRef(noop)
  const setRef = useCallback((el: HTMLElement | null): void => {
    cleanupFn.current()

    if (!PREVIEW && el) {
      cleanupFn.current = stopAllEventsPropagation(el)
    }
  }, [])

  return { ref: setRef }
}
